module.exports = __webpack_public_path__ + "src/assets/img/login-bg-180.png";